export default (() => {
  const {
    NODE_ENV,
    VUE_APP_DEV_AS_WXWORK,
    VUE_APP_DEV_AS_WECHAT,
    VUE_APP_ENABLE_MOCK,
    VUE_APP_ENABLE_VCONSOLE,
    VUE_APP_VERSION,
    VUE_APP_DEV_BRAND_ID,
    VUE_APP_API_URL,
  } = process.env;

  // Ensure all environment variables are strings
  const configs = {
    isProduction: NODE_ENV === "production",
    isDevelopment: NODE_ENV === "development",
    isDevelopAsInWxWork: false,
    isDevelopAsInWeChat: false,
    isMockEnabled: NODE_ENV === "development" && VUE_APP_ENABLE_MOCK === "YES",

    enableVConsole: VUE_APP_ENABLE_VCONSOLE === "YES",
    baseApiUrl: VUE_APP_API_URL || "/",

    VERSION: VUE_APP_VERSION || "1.0.0",
    brandId: -1,
  };

  if (configs.isDevelopment) {
    configs.brandId = VUE_APP_DEV_BRAND_ID;
    if (VUE_APP_DEV_AS_WXWORK === "YES") {
      configs.isDevelopAsInWxWork = true;
    } else if (VUE_APP_DEV_AS_WECHAT === "YES") {
      configs.isDevelopAsInWeChat = true;
    }
  }

  return configs;
})();
